.usersHeaderContainer {
  display: flex;
  align-items: center;
}

.usersHeaderContainer h3 {
  flex-grow: 1;
}

.pageControls {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0.5em;

  & span {
    margin: 0.5em;
    align-self: center;
  }
}
